import RichTextEditor from '../../RichTextEditor.jsx';
import React, { useEffect } from 'react';

const EditDisplayTextForm = ({ settings, setSettings }) => {
    return (
        <div>
            <div className="input-label mt-4">Content</div>
            <RichTextEditor
                initialValue={settings?.display || ''}
                onChange={value => setSettings({ ...settings, display: value })}
            />
        </div>
    );
};

export default EditDisplayTextForm;
